import React, { Component } from "react";
import { Images } from "../../components";
import { ReactSVG } from "react-svg";

export class Features extends Component {
  render() {
    return (
      <div className="features">
        {this.props.luckyNumberFooters.map((item) => {
          return (
            <div className="feature-card" key={item.imageText}>
              <ReactSVG
                src={item.imageLuckyNumbersFooterPath}
                alt="selection"
              />
              <h4>{item.imageText}</h4>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Features;
